import React from "react";

import useTheme from "../../../../common/hooks/useTheme";
import IntervalIconSvg from "../../../../common/svgs/IntervalIconSvg";
import ResistanceIconSvg from "../../../../common/svgs/ResistanceIconSvg";
import CardioIconSvg from "../../../../common/svgs/CardioIconSvg";
import RestDayIconSvg from "../../../../common/svgs/RestDayIconSvg";
import IsCompletedIcon from "../../svg/IsCompletedIcon";
import { findMealType } from "../../../../providers/helperFunctions";

type Props = {
  type: string;
  data: any;
};
const DailyLog = ({ type, data }: Props) => {
  const theme = useTheme();

  if (!data) {
    return null;
  }

  let completedLogs;

  if (type === "workout") {
    completedLogs = data.filter((el: any) => el.is_completed === true).length;
  } else {
    completedLogs = data.filter((el: any) => el.is_logged).length;
  }

  const totalLogs = data.length;

  const getWorkoutIcon = (type: number, fill: string) => {
    switch (type) {
      case 0:
        //   return "None";
        // case 1:
        return <IntervalIconSvg fill={fill} width={12} height={12} />;
      case 2:
        return <ResistanceIconSvg fill={fill} width={12} height={12} />;
      case 3:
        return <CardioIconSvg fill={fill} width={12} height={12} />;
      case 4:
        return <RestDayIconSvg fill={fill} width={12} height={12} />;
    }
  };

  const RestDayCard = () => {
    return (
      <div style={styles.itemInner(theme, false)}>
        <div style={{ ...styles.itemLabelContainer, padding: "8px 0" }}>
          {getWorkoutIcon(4, theme.colors_ds.NEUTRAL_ICON_WEAK)}
          <div style={styles.itemLabel(theme)}>Rest day</div>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.title(theme)}>{`Daily ${
        type === "workout" ? "tasks" : "meals"
      }`}</div>

      {totalLogs > 0 ? (
        <div>
          <div style={styles.barContainer(theme)}>
            <div style={styles.barInner(theme, completedLogs, totalLogs)} />
          </div>
          <div style={styles.valueContainer}>
            <span style={styles.value(theme)}>{completedLogs}</span>
            <span style={styles.maxValue(theme)}>{`/${totalLogs} ${
              type === "workout" ? "tasks" : "meals"
            } completed`}</span>
          </div>
          <div style={styles.itemsContainer(data.length)}>
            {data.map((log: any, index: number) => (
              <div
                key={index}
                style={styles.itemInner(
                  theme,
                  type === "workout" ? log.is_completed : log.is_logged
                )}
              >
                <div style={styles.itemLabelContainer}>
                  {type === "workout" ? (
                    <div style={styles.iconContainer(theme, log.is_completed)}>
                      {getWorkoutIcon(
                        log.type,
                        theme.colors_ds.NEUTRAL_BG_MAIN
                      )}
                    </div>
                  ) : (
                    <IsCompletedIcon
                      fill={
                        log.is_logged
                          ? theme.colors_ds.SUCCESS_ICON_MAIN
                          : theme.colors_ds.NEUTRAL_ICON_WEAK
                      }
                      size={16}
                    />
                  )}
                  <div style={styles.itemLabel(theme)}>
                    {type === "workout" ? log.name : findMealType(log.type)}
                  </div>
                </div>
                {type === "workout" ? (
                  <div style={{ ...styles.itemLabelContainer, gap: "8px" }}>
                    <div style={styles.details(theme)}>
                      {`${log.properties.goal.current} /`}
                      <span
                        style={{
                          fontFamily: "var(--font-Medium)",
                          color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
                        }}
                      >
                        {` ${log.properties.goal.target} kcal`}
                      </span>
                    </div>
                    <div style={styles.details(theme)}>
                      {log.properties.duration_in_minutes}
                      <span
                        style={{
                          fontFamily: "var(--font-Medium)",
                          color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
                        }}
                      >
                        {" min"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div style={styles.details(theme)}>
                    {Math.round(log.cals.target)}
                    <span
                      style={{
                        fontFamily: "var(--font-Medium)",
                        color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
                      }}
                    >
                      {" "}
                      kcal
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>{type === "workout" && <RestDayCard />}</div>
      )}
    </div>
  );
};

export default DailyLog;

const styles = {
  container: {
    marginTop: "32px",
  },
  title: (theme: any) => ({
    marginBottom: "8px",
    alignSelf: "flex-start",
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  barContainer: (theme: any) => ({
    height: "6px",
    backgroundColor: theme.colorTokens.S[10],
    borderRadius: "38px",
    overflow: "hidden",
  }),
  barInner: (theme: any, completedLogs: number, totalLogs: number) => ({
    height: "100%",
    width: `${(completedLogs * 100) / totalLogs}%`,
    backgroundColor: theme.colorTokens.S[60],
    borderRadius: "38px",
  }),
  valueContainer: {},
  value: (theme: any) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "10px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    lineHeight: "14px",
  }),
  maxValue: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "10px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    lineHeight: "14px",
  }),
  itemsContainer: (tasks: number) => ({
    marginTop: "8px",
    display: "grid",
    gap: "8px",
    gridTemplateColumns: tasks > 1 ? "1fr 1fr" : "1fr",
  }),
  itemInner: (theme: any, completed: boolean) => ({
    padding: "8px 12px",
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
    border: `1px solid ${
      completed
        ? theme.colors_ds.SUCCESS_ICON_MAIN
        : theme.colors_ds.NEUTRAL_BORDER_DEFAULT
    }`,
    borderRadius: "8px",
    backgroundColor: completed ? theme.colorTokens.S[10] : "transparent",
  }),
  itemLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  iconContainer: (theme: any, completed: boolean) => ({
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: completed
      ? theme.colors_ds.SUCCESS_ICON_MAIN
      : theme.colors_ds.NEUTRAL_ICON_WEAK,
  }),
  itemLabel: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    lineHeight: "14px",
  }),
  details: (theme: any) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    lineHeight: "16px",
  }),
};
